import { Card } from "@mantine/core";
import { useColors } from "../../../hooks/colors/useColors";
import { MyH1 } from "../../UI/my-h1/MyH1";
import { ReactNode } from "react";
import { isPhone } from "../../../constants/env";
import { isTablet } from "react-device-detect";

type InputProps = {
  title: string;
  onClick: () => void;
  imageSrc: string;
  icon: ReactNode;
};

export function MenuRectangle(props: InputProps) {
  const { colors } = useColors();
  const { title, onClick, imageSrc, icon } = props;

  function getHeightAndWidth(): string | number {
    if (isPhone) {
      return window.innerWidth - 32;
    } else if (isTablet) {
      return "20rem";
    } else {
      return 400;
    }
  }
  return (
    <Card
      className="hover"
      radius="xl"
      style={{
        backgroundColor: colors.success,
        color: colors.white,
        backgroundImage: `url(${imageSrc})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
        padding: 0,
        width: getHeightAndWidth(),
        height: getHeightAndWidth(),
      }}
      onClick={onClick}
      // className={}
    >
      <div
        style={{
          backgroundColor: colors.success,
          opacity: 0.88,
          width: getHeightAndWidth(),
          height: getHeightAndWidth(),
          // height: 320,
        }}
        className="flex flex-col justify-center items-center"
      >
        <MyH1 size={40} color="white" className="text-center">
          <span dangerouslySetInnerHTML={{ __html: title }}></span>
        </MyH1>
        {icon}
      </div>
    </Card>
  );
}
